import { Action, AwsWafConfig } from '../types';

/**
 * State for the AWS WAF CAPTCHA feature.
 *
 * The token itself is _not_ stored in state, because it is stored in a cookie by the AWS Captcha SDK, meaning that we
 * won't know when/if it updates, so we want to fetch the value as close as possible to the time it's used
 */
export interface State {
  /* Whether or not the modal that we render the AWS Captcha challenge puzzle in is open */
  isCaptchaPuzzleModalOpen: boolean;
  /**
   * The configuration used to include the AWS Captcha SDK and render captcha puzzles, resolved for
   * the current hostname. Absent when the edge endpoint is unavailable, when no API key covers this
   * hostname, or on FedRAMP Moderate — all of which mean "no CAPTCHA".
   *
   * Owned by this slice rather than `appConfig` because it comes from the WAF's own same-origin
   * `/_edge/waf/config` endpoint, not from `/frontend/state`.
   *
   * Prefer accessing via the `useAwsWafConfig` hook over reading this state directly.
   */
  config?: AwsWafConfig;
}

export const defaultState: State = {
  isCaptchaPuzzleModalOpen: false,
  config: undefined,
};

const awsCaptcha = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'OPEN_AWS_CAPTCHA_MODAL':
      return {
        ...state,
        isCaptchaPuzzleModalOpen: true,
      };
    case 'CLOSE_AWS_CAPTCHA_MODAL':
      return {
        ...state,
        isCaptchaPuzzleModalOpen: false,
      };
    default:
      return state;
  }
};

export default awsCaptcha;
